import { useCompanyKeyInformationSectionQuery } from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { useMemo } from 'react';



export interface IData {
  marketCap: string;
  stock52High: string;
  stock52Low: string;
  divYield: string;
  sharesOutstanding: string;
  avgDailyVolume: string;
  firstTradingDate: string;
  sector: string;
  industry: string;
  nextEarningsReport: string;
  employeeCount: string;
}

export function useQuery(listedCompanyId: string) {
  const tuple = useCompanyKeyInformationSectionQuery({
    variables: {
      listedCompanyId
    },
    returnPartialData: true
  });

  return useMemo(
    () => {
      const company = tuple.data?.listedCompany;
      const latestStockPrice = company?.latestStockPrice;
      const data: IData = {
        marketCap: company?.standardGlAccounts.marketcap?.mostRecentValue?.formattedValue ?? '-',
        stock52High: latestStockPrice?.fiftyTwoWeekHigh.toFixed(2) ?? '-',
        stock52Low: latestStockPrice?.fiftyTwoWeekLow.toFixed(2) ?? '-',
        divYield: company?.standardGlAccounts.dividendyield?.mostRecentValue?.formattedValue ?? '-',
        sharesOutstanding: company?.standardGlAccounts.weightedavebasicsharesos?.mostRecentValue?.formattedValue ?? '-',
        avgDailyVolume: company?.averageVolume?.toFixed(0) ?? '-',
        firstTradingDate: _.isString(company?.companyStatistics.firstTradingDate) ? DateTime.fromISO(company?.companyStatistics.firstTradingDate).toFormat('MMMM d, yyyy') : (company?.companyStatistics.firstTradingDate?.toFormat('MMMM d, yyyy') ?? '-'),
        sector: company?.sector.displayName ?? '-',
        industry: company?.industry.displayName ?? '-',
        employeeCount: company?.companyStatistics.numberOfEmployees.toString() ?? '-',
        nextEarningsReport: company?.companyStatistics.nextEarningsReportDate?.toFormat('MMMM d, yyyy') ?? '-'
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
